import styled from "styled-components";
import image from "../../images/common/NewPremiumBadge.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglass } from '@fortawesome/free-solid-svg-icons';

const PremiumOffer = ({}) => {

  const handleClickBuy = () => {
    return
  }

  return (
    <Container>
      <OuterContainer className="gradient-gray gray-border">
        <InnerContainer className="gradient-gray">
          <div className="row">
            <LeftColumn className="col-md-5 col-sm-12">
              <ImageContainer>
                <Img src={image}></Img>
              </ImageContainer>
              <ButtonContainer>
              <button onClick={handleClickBuy} type="button" className="btn btn-success btn-lg">
                  <FontAwesomeIcon icon={faHourglass} /> Coming Soon
              </button>
              </ButtonContainer>
            </LeftColumn>
            <RightColumn className="col-md-7 col-sm-12">
              <TitleContainer>
                <Title className="heading fw-bold">VGC Premium</Title>
              </TitleContainer>
              <PriceContainer>
                <PriceText className="heading">£5.99pm</PriceText>
              </PriceContainer>
              <DiscriptionContainer>
                <BeneftsText className="fw-bold ">
                  The Benefits of Premium
                </BeneftsText>
                <Description>
                  {/* <br></br> */}- Access to Discord Channels for Fut and
                  Career <br></br>- Premium Member Profile Badge<br></br>-
                  Unlimited Releaces as Manager of website<br></br>- Release
                  youtself as a player of website<br></br>- Extend Kick-Off by
                  10 Minutes<br></br>- 5 Reschedules Per Season
                </Description>
              </DiscriptionContainer>
            </RightColumn>
          </div>
        </InnerContainer>
      </OuterContainer>
    </Container>
  );
};

export default PremiumOffer;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 1rem;
  /* @media (max-width: 992px) {
        padding: 1rem 8rem;
    }
    @media (max-width: 768px) {
        padding: 1rem 2rem;
    } */
  /* @media (min-width: 768px) {
        margin: 3rem;
    }  */
`;
const OuterContainer = styled.div`
  background-color: #2e2e2e;
  /* background-color: rgb(38, 38, 38); */
  border: 0.5px solid gray;
  padding: 0.7rem;
  border-radius: 8px;
`;
const InnerContainer = styled.div`
  background-color: #2e2e2e;
  /* background-color: rgb(38, 38, 38); */
  border: 5px solid rgb(250, 252, 43, 0.7);
  padding: 1rem;
  border-radius: 8px;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  /* @media (max-width: 992px) {
        height: 100%;
    } */
  /* outline: red 2px solid; */
`;
const ImageContainer = styled.div`
  /* height: 50%; */
  padding: 0.5rem;
`;
const Img = styled.img`
  height: 200px; // change this to make responsive
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  @media (min-width: 420px) {
    padding: 1rem 0;
    font-size: medium;
  }
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
const TitleContainer = styled.div`
  padding: 0.5rem 0;
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
`;
const Title = styled.h2`
  padding: 0;
  margin: 0;
`;
const PriceContainer = styled.div`
  padding: 0.5rem;
  @media (min-width: 768px) {
    padding: 1rem;
  }
`;
const PriceText = styled.h2`
  padding: 0;
  margin: 0;
`;
const DiscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Description = styled.p`
  padding: 0;
  margin: 0.5rem 0;
  font-size: smaller;
  @media (min-width: 420px) {
    margin: 1rem 0;
    font-size: medium;
  }
`;
const BeneftsText = styled.h4`
  margin: 0;
  text-decoration: underline;
  padding: 0.5rem;
`;
